import { useEffect, useState } from "react";
import UpdatesHeader from "../common/UpdatesHeader/UpdatesHeader";
import UpdatesTab from "../common/UpdatesTab/UpdatesTab";
import EmailUpdatesTable from "./EmailUpdatesTable/EmailUpdatesTable";
import API from "services/lib/api";
import { apiRoute } from "services";
import {
    CANNED_RESOURCE_ACTIONS,
    CANNED_RESOURCE_TYPES,
} from "../../CannedResponses/enum";
import { getErrorMessage, getPageFromCache } from "utils/helper";
import { Empty, Loading } from "components/ui";
import ErrorView from "components/ui/ErrorView/ErrorView";
import CustomPagination from "components/dashboard/common/CustomPagination/CustomPagination";
import { dataQueryStatus } from "utils";
import { baseResources, baseResourceActions } from "routes/enum";
import CannedUpdatesModal from "../common/modal/CannedUpdatesModal/CannedUpdatesModal";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setCannedEmailsFilterOption, setEmailUpdatesFilterParams } from "store/filters/actions";
import {
    clearEmailUpdates,
    saveEmailUpdates,
} from "store/modules/agentAssistance/actions";

const { KB_AGENT_GUIDE_EMAIL_UPDATE } = baseResources;
const { CREATE } = baseResourceActions;

const { IDLE, LOADING, ERROR, DATAMODE, NULLMODE } = dataQueryStatus;

const { CREATE_CANNED_RESOURCE, EDIT_CANNED_RESOURCE, VIEW_CANNED_RESOURCE } =
    CANNED_RESOURCE_ACTIONS;

const EmailUpdates = () => {
    const [errorMssg, setErrorMssg] = useState();
    const [showModal, toggleModal] = useState(false);
    const [cannedUpdates, setCannedUpdates] = useState([]);

    const [selectedCannedUpdate, selectCannedUpdate] = useState();

    const [modalAction, setModalAction] = useState();

    const [tableIsLoading, setTableIsLoading] = useState(false);
    const [useTableLoader, setUseTableLoader] = useState(false);
    const [searchIsLoading, setSearchIsLoading] = useState(false);
    const [clearSearch, setClearSearch] = useState(false);

    const {
        emailUpdatesCache: { pages, totalRecords },
    } = useSelector((state) => state.agentAssistance);

    const { baseFilter, filterOption, filterParams } = useSelector(
        (state) => state?.filters?.emailUpdatesFilters
    );

    const [status, setStatus] = useState(
        pages[filterParams?.currentPage]?.length > 0 ? DATAMODE : IDLE
    );

    const agentUpdateType = CANNED_RESOURCE_TYPES?.CANNED_EMAIL;

    const dispatch = useDispatch();

    const handleSearch = (search) => {
        setUseTableLoader(true);
        setSearchIsLoading(true);
        setClearSearch(false);

        dispatch(setEmailUpdatesFilterParams({ currentPage: 1, search }));
        dispatch(clearEmailUpdates());
    };

    const handlePageChange = (currentPage) => {
        setUseTableLoader(true);

        dispatch(setEmailUpdatesFilterParams({ ...filterParams, currentPage }));
    };

    const getCannnedUpdates = async () => {
        try {
            setErrorMssg();
            useTableLoader && setTableIsLoading(true);
            if (cannedUpdates?.length < 1 && filterParams?.search < 1) {
                setStatus(LOADING);
            }

            const url = apiRoute.getCannedUpdates;
            const res = await API.get(url, {
                params: {
                    agentUpdateType,
                    ...filterParams,
                },
            });

            if (res.status === 200) {
                filterParams?.search?.length > 0 && setUseTableLoader(true);
                const { data, metaData } = res.data;
                let newStatus = data.length > 0 ? DATAMODE : NULLMODE;
                setCannedUpdates(data);

                dispatch(
                    saveEmailUpdates(
                        filterParams?.currentPage,
                        metaData?.totalRecords,
                        data
                    )
                );
                setStatus(newStatus);
                setSearchIsLoading(false);
                setTableIsLoading(false);
            }
        } catch (err) {
            setSearchIsLoading(false);
            setErrorMssg(getErrorMessage(err));
            useTableLoader ? setTableIsLoading(false) : setStatus(ERROR);
        }
    };

    const handleSuccess = () => {
        dispatch(setEmailUpdatesFilterParams({ currentPage: 1, search: "" }));
        dispatch(clearEmailUpdates());
        setClearSearch(true);
        getCannnedUpdates();
    };

    const handleBasefilter = (baseFilter) => {
        dispatch(setEmailUpdatesFilterParams(baseFilter));
        dispatch(setCannedEmailsFilterOption({}));
    };

    const handleSortByAlpha = (value, option) => {
        setUseTableLoader(true);
        dispatch(
            setEmailUpdatesFilterParams({
                ...filterParams,
                alphabetical: value,
                dateCreated: null,
                lastModified: null,
            })
        );
        dispatch(setCannedEmailsFilterOption({ ...option, value }));
        dispatch(clearEmailUpdates());
    };

    const handleSortByDate = (value, option) => {
        setUseTableLoader(true);
        dispatch(
            setEmailUpdatesFilterParams({
                ...filterParams,
                dateCreated: value,
                alphabetical: null,
                lastModified: null,
            })
        );
        dispatch(setCannedEmailsFilterOption({ ...option, value }));
        dispatch(clearEmailUpdates());
    };

    const handleSortByLastModified = (value, option) => {
        dispatch(
            setEmailUpdatesFilterParams({
                ...filterParams,
                dateCreated: null,
                alphabetical: null,
                lastModified: value,
            })
        );
        dispatch(setCannedEmailsFilterOption({ ...option, value }));
        dispatch(clearEmailUpdates());
    };

    const history = useHistory();

    const routeToViewUpdate = ({ agentUpdateId }) => {
        return history.push(`/t-sam/updates/email/view/${agentUpdateId}`);
    };

    const handleActionModal = (actionType, cannedResource) => {
        if (actionType === VIEW_CANNED_RESOURCE) {
            return routeToViewUpdate(cannedResource);
        }
        setModalAction(actionType);
        toggleModal(true);
        selectCannedUpdate(cannedResource);
    };

    const renderBasedOnStatus = () => {
        switch (status) {
            case IDLE:
                return "";

            case LOADING:
                return <Loading />;

            case ERROR:
                return (
                    <ErrorView
                        message={errorMssg}
                        handleRetry={getCannnedUpdates}
                    />
                );

            case NULLMODE:
                return <Empty text={"No Canned Update Available Yet"} />;

            case DATAMODE:
                return (
                    <>
                        <EmailUpdatesTable
                            handleSuccess={handleSuccess}
                            handleActionModal={handleActionModal}
                            modalAction={modalAction}
                            cannedUpdates={cannedUpdates}
                            cannedResourceType={agentUpdateType}
                            tableIsLoading={tableIsLoading}
                        />
                        <CustomPagination
                            totalRecords={totalRecords}
                            handlePageChange={handlePageChange}
                            {...filterParams}
                        />
                    </>
                );

            default:
                return "";
        }
    };

    useEffect(() => {
        const cachedPage = getPageFromCache(pages, filterParams.currentPage);
        if (cachedPage?.length > 0 && !searchIsLoading) {
            setCannedUpdates(cachedPage);
        } else {
            getCannnedUpdates();
        }
        // eslint-disable-next-line
    }, [filterParams, useTableLoader]);

    const isEdit = modalAction === EDIT_CANNED_RESOURCE;

    return (
        <>
            <UpdatesTab />
            <div className='padded__layout'>
                <UpdatesHeader
                    title={"Email updates"}
                    btnText={"New update"}
                    placeholder={"Search updates here"}
                    baseResources={[`${CREATE}_${KB_AGENT_GUIDE_EMAIL_UPDATE}`]}
                    handleClick={() =>
                        handleActionModal(CREATE_CANNED_RESOURCE)
                    }
                    handleSearch={handleSearch}
                    searchIsLoading={searchIsLoading}
                    clearSearch={clearSearch}
                    defaultValue={filterParams?.search}
                    {
                        ...{
                            handleSortByAlpha,
                            handleSortByDate,
                            handleSortByLastModified,
                            baseFilter,
                            filterOption,
                            handleBasefilter
                        }
                    }
                />
                {renderBasedOnStatus()}
            </div>

            {showModal && (
                <CannedUpdatesModal
                    showModal={showModal}
                    title={isEdit ? "Modify Email Update " : "New Email Update"}
                    handleSuccess={handleSuccess}
                    closeModal={() => toggleModal(false)}
                    cannedResourceType={agentUpdateType}
                    modalAction={modalAction}
                    selectedCannedUpdate={selectedCannedUpdate}
                    isEdit={isEdit}
                />
            )}
        </>
    );
};

export default EmailUpdates;
